import { Injectable } from '@angular/core';
import { RunningEnvResponse, UserInfo, UserPoolInfo, UserPoolPrecis } from 'src/app/shared/auto-generated-devumconsole/models/auto-generated-models';
import { CustomUserDetails } from 'src/app/shared/extends/models/extended.models';
import { WebStorageEnum } from '../../../../libs/dc-core/constants/constant';
import { DataEntity } from '../../../../libs/dc-core/models/base.models';
import { SessionStorageProvider } from '../../../../libs/dc-core/providers/abstract/session-storage-provider';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService extends SessionStorageProvider {

  localStorageItems: any;
  lsKey: any;

  constructor() {
    super();
    this.initailzeLocaStorageItems();
  }

  private initailzeLocaStorageItems() {
    this.setLocalStorageItemsToSessionStorage();

  }

  setLocalStorageItemsToSessionStorage() {
    this.localStorageItems = JSON.parse(localStorage.getItem(WebStorageEnum.SITE));
  }
  setLocalStorageKey(siteId: number) {
    this.lsKey = JSON.stringify(siteId);
  }
  getLocalStorageKey() {
    return `s_${this.lsKey}`;
  }

  clearLocalStorage() {
    this.localStorageItems = {};
  }
  getModuleId(): number {
    return this.getValueByKey(WebStorageEnum.MODULE_ID) ? JSON.parse(this.getValueByKey(WebStorageEnum.MODULE_ID)) as number : undefined;
  }

  private getValueByKey(key: string) {
    const siteObj = JSON.parse(localStorage.getItem(WebStorageEnum.SITE));
    if (siteObj && key in siteObj && siteObj[key]) {
      return siteObj[key];
    } else {
      return undefined;
    }
  }
  private convertToString(value: any): string {
    return JSON.stringify(value);
  }

  private setStorageBySite(key: string, value: string) {
    // GET S_1 WHICH IS SITEID FROM THE URL e.g http://192.168.1.155/hf/S_1
    this.localStorageItems = { ...this.localStorageItems, [key]: value }
    localStorage.setItem(WebStorageEnum.SITE, JSON.stringify(this.localStorageItems));
  }

  setRunningEnv(data: RunningEnvResponse) {
    this.setStorageBySite(WebStorageEnum.RUNNING_ENV, this.convertToString(data));
  }

  setCognitoToken(data: string) {
    this.setStorageBySite(WebStorageEnum.AUTHORIZATION_KEY, data);
  }

  setLogInInfo(data: boolean) {
    this.setStorageBySite(WebStorageEnum.LOGGED_IN, this.convertToString(data));
  }
  getLogInInfo() {
    return this.getValueByKey(WebStorageEnum.LOGGED_IN) ? JSON.parse(this.getValueByKey(WebStorageEnum.LOGGED_IN)) : undefined;
  }

  getUserProfile(): CustomUserDetails {
    return this.getValueByKey(WebStorageEnum.USER_PROFILE) ? JSON.parse(this.getValueByKey(WebStorageEnum.USER_PROFILE)) as CustomUserDetails : undefined;
  }
  setUserProfile(data: CustomUserDetails) {
    this.setStorageBySite(WebStorageEnum.USER_PROFILE, this.convertToString(data));
  }

  getUserInfo(): UserInfo {
    return this.getValueByKey(WebStorageEnum.USER_INFO) ? JSON.parse(this.getValueByKey(WebStorageEnum.USER_INFO)) as UserInfo : undefined;
  }

  setUserInfo(data: UserInfo) {
    this.setStorageBySite(WebStorageEnum.USER_INFO, this.convertToString(data));
  }

  getCognitoProfile(): any {
    return this.getValueByKey(WebStorageEnum.COGNITO_PROFILE) ? JSON.parse(this.getValueByKey(WebStorageEnum.COGNITO_PROFILE)) : undefined;
  }
  setCognitoProfile(data: any) {
    this.setStorageBySite(WebStorageEnum.COGNITO_PROFILE, this.convertToString(data));
  }
  getAuthState(): any {
    return this.getValueByKey(WebStorageEnum.AUTH_STATE) ? JSON.parse(this.getValueByKey(WebStorageEnum.AUTH_STATE)) : undefined;
  }
  setAuthState(data: any) {
    this.setStorageBySite(WebStorageEnum.AUTH_STATE, this.convertToString(data));
  }
  // getModuleDeployment(): ModuleDeployment[] {
  //   return this.getValueByKey(WebStorageEnum.MODULE_DEPLOYMENT) ? JSON.parse(this.getValueByKey(WebStorageEnum.MODULE_DEPLOYMENT)) as ModuleDeployment[] : undefined;
  // }
  // setModuleDeployment(data: ModuleDeployment[]) {
  //   this.setStorageBySite(WebStorageEnum.MODULE_DEPLOYMENT, this.convertToString(data));
  // }
  getCurrencyConverter(): any {
    return this.getValueByKey(WebStorageEnum.CURRENCY_CONVERTER) ? JSON.parse(this.getValueByKey(WebStorageEnum.CURRENCY_CONVERTER)) as any : undefined;
  }
  setCurrencyConverter(data: any) {
    this.setStorageBySite(WebStorageEnum.CURRENCY_CONVERTER, this.convertToString(data));
  }

  getCognitoToken(): string {
    return this.getValueByKey(WebStorageEnum.AUTHORIZATION_KEY);
  }

  getRunningEnv(): RunningEnvResponse {
    return this.getValueByKey(WebStorageEnum.RUNNING_ENV) ? JSON.parse(this.getValueByKey(WebStorageEnum.RUNNING_ENV)) as any : undefined;

  }
  setUserPool(data: UserPoolPrecis) {
    this.setStorageBySite(WebStorageEnum.USERPOOL, this.convertToString(data));
  }

  getUserPool(): UserPoolPrecis {
    return this.getValueByKey(WebStorageEnum.USERPOOL) ? JSON.parse(this.getValueByKey(WebStorageEnum.USERPOOL)) as any : undefined;
  }

  getDbKey(): string {
    const dbKey = this.getValueByKey(WebStorageEnum.DB_KEY);
    if (!dbKey) {
      const newDBKey = `${WebStorageEnum.DB_KEY_PREFIX}-${this.guid()}`;
      this.setDbKey(newDBKey);
      return newDBKey
    } else {
      return dbKey;
    }
  }
  setDbKey(data: string) {
    this.setStorageBySite(WebStorageEnum.DB_KEY, data);
  }
  getDataEntities(): string {
    return this.getValueByKey(WebStorageEnum.DATA_ENTITY);
  }
  setDataEntities(data: DataEntity[]) {
    this.setStorageBySite(WebStorageEnum.DATA_ENTITY, this.convertToString(data));
  }
  private guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }

  clearSession() {
    localStorage.clear();
    this.localStorageItems = {};
  }

  setCurrentPage(data: string) {
    this.setStorageBySite(WebStorageEnum.CURRENT_PAGE, data);
  }

  getCurrentPage(): string {
    return this.getValueByKey(WebStorageEnum.CURRENT_PAGE);
  }

  getIsInfraRegistered(): boolean {
    return this.getValueByKey(WebStorageEnum.INFRA_REGISTERED) ? JSON.parse(this.getValueByKey(WebStorageEnum.INFRA_REGISTERED)) : undefined;
  }

  setIsInfraRegistered(data: boolean): void {
    this.setStorageBySite(WebStorageEnum.INFRA_REGISTERED, this.convertToString(data));
  }

  getIsAgentInstalled(): boolean {
    return this.getValueByKey(WebStorageEnum.IS_AGENT_INSTALLED) ? JSON.parse(this.getValueByKey(WebStorageEnum.IS_AGENT_INSTALLED)) : undefined;
  }

  setIsAgentInstalled(data: boolean): void {
    this.setStorageBySite(WebStorageEnum.IS_AGENT_INSTALLED, this.convertToString(data));
  }

  getRegion(): string {
    return this.getValueByKey(WebStorageEnum.REGION);
  }
  setRegion(data: string): void {
    this.setStorageBySite(WebStorageEnum.REGION, data);
  }

  getDataCenterRegion(): string {
    return this.getValueByKey(WebStorageEnum.DC_REGION);
  }
  setDataCenterRegion(data: string): void {
    this.setStorageBySite(WebStorageEnum.DC_REGION, data);
  }

}
